import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";

import DeleteModal from "../../../../Components/Common/DeleteModal";

import { toast } from "react-toastify";

import {
  addNewPurchaseItemCategory,
  addNewPurchaseItemCategorySuccess,
  addNewPurchaseStatus,
  addNewPurchaseStatusSuccess,
  deletePurchaseItemCategory,
  deletePurchaseItemCategorySuccess,
  deletePurchaseStatus,
  deletePurchaseStatusSuccess,
  getPurchaseItemCategoryList,
  getPurchaseStatusList,
  updatePurchaseItemCategory,
  updatePurchaseItemCategorySuccess,
  updatePurchaseStatus,
  updatePurchaseStatusSuccess,
} from "../../../../store/purchase/action";
import {
  createPurchaseDraftStatus,
  createPurchaseDraftStatusSuccess,
  deletePurchaseDraftStatus,
  deletePurchaseDraftStatusSuccess,
  getPurchaseDraftStatusList,
  updatePurchaseDraftStatus,
  updatePurchaseDraftStatusSuccess,
} from "../../../../store/PurchaseDraft/action";
export default function PurchasesSettings() {
  const dispatch = useDispatch();

  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    FlagCostOfGoodsSold: null,
  });

  const {
    purchaseStatusListAPI,
    purchaseItemCategoryListAPI,
    purchaseDraftStatusListAPI,
  } = useSelector((state) => ({
    purchaseStatusListAPI:
      state.Purchase.purchaseStatusList?.purchasestatus_list,
    purchaseItemCategoryListAPI:
      state.Purchase.purchaseItemCategoryList?.purchaseitemcategory_list,
    purchaseDraftStatusListAPI:
      state.PurchaseDraft.purchaseDraftStatusList?.purchasedraftstatus_list,
  }));

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      //   Status create
      dispatch(addNewPurchaseStatus([createStatus]));
    }
    if (activeTab === "2") {
      //   Status create
      dispatch(addNewPurchaseItemCategory([createStatus]));
    }
    if (activeTab === "3") {
      //   Status create
      dispatch(createPurchaseDraftStatus([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = purchaseStatusListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "2") {
      data = purchaseItemCategoryListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "3") {
      data = purchaseDraftStatusListAPI?.sort((a, b) => b.Id - a.Id);
    }

    setStatusList(data);
  }, [
    purchaseStatusListAPI,
    purchaseItemCategoryListAPI,
    purchaseDraftStatusListAPI,
    activeTab,
  ]);

  useEffect(() => {
    dispatch(getPurchaseStatusList());
    dispatch(getPurchaseItemCategoryList());
    dispatch(getPurchaseDraftStatusList());
  }, []);

  const Tabs = [
    {
      id: "1",
      name: "Purchase Statuses",
    },
    {
      id: "2",
      name: "Purchase Item Category",
    },
    {
      id: "3",
      name: "Purchase Draft Statuses",
    },
  ];
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //   Status delete
      dispatch(deletePurchaseStatus([deleteStatus]));
    }
    if (activeTab === "2") {
      //   Status delete
      dispatch(deletePurchaseItemCategory([deleteStatus]));
    }
    if (activeTab === "3") {
      //   Status delete
      dispatch(deletePurchaseDraftStatus([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      ...(activeTab === "2" && {
        FlagCostOfGoodsSold: updateItemStatus?.FlagCostOfGoodsSold,
      }),
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        //  Status update
        dispatch(updatePurchaseStatus([updateNewStatus]));
      }
      if (activeTab === "2") {
        //  Status update
        dispatch(updatePurchaseItemCategory([updateNewStatus]));
      }
      if (activeTab === "3") {
        //  Status update
        dispatch(updatePurchaseDraftStatus([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  // Effects
  const {
    addNewPurchaseStatusSuccessAPI,
    deletePurchaseStatusSuccessAPI,
    updatePurchaseStatusSuccessAPI,

    addNewPurchaseItemCategorySuccessAPI,
    deletePurchaseItemCategorySuccessAPI,
    updatePurchaseItemCategorySuccessAPI,
    purchaseDraftStatusCreateAPI,
    purchaseDraftStatusDeleteAPI,
    purchaseDraftStatusUpdateAPI,
  } = useSelector((state) => ({
    addNewPurchaseStatusSuccessAPI: state.Purchase.addNewPurchaseStatusSuccess,
    deletePurchaseStatusSuccessAPI: state.Purchase.deletePurchaseStatusSuccess,
    updatePurchaseStatusSuccessAPI: state.Purchase.updatePurchaseStatusSuccess,
    addNewPurchaseItemCategorySuccessAPI:
      state.Purchase.addNewPurchaseItemCategorySuccess,
    deletePurchaseItemCategorySuccessAPI:
      state.Purchase.deletePurchaseItemCategorySuccess,
    updatePurchaseItemCategorySuccessAPI:
      state.Purchase.updatePurchaseItemCategorySuccess,
    purchaseDraftStatusCreateAPI: state.PurchaseDraft.purchaseDraftStatusCreate,
    purchaseDraftStatusDeleteAPI: state.PurchaseDraft.purchaseDraftStatusDelete,
    purchaseDraftStatusUpdateAPI: state.PurchaseDraft.purchaseDraftStatusUpdate,
  }));

  // Add New Status
  useEffect(() => {
    if (isEmpty(addNewPurchaseStatusSuccessAPI)) return;
    if (addNewPurchaseStatusSuccessAPI?.status === 200) {
      toast.success(addNewPurchaseStatusSuccessAPI?.message);
      dispatch(getPurchaseStatusList());
    } else {
      toast.error(addNewPurchaseStatusSuccessAPI?.message);
    }
    dispatch(addNewPurchaseStatusSuccess([]));
  }, [addNewPurchaseStatusSuccessAPI]);

  // Delete Status
  useEffect(() => {
    if (isEmpty(deletePurchaseStatusSuccessAPI)) return;
    if (deletePurchaseStatusSuccessAPI?.status === 200) {
      toast.success(deletePurchaseStatusSuccessAPI?.message);
      dispatch(getPurchaseStatusList());
      setDeleteModal(false);
    } else {
      toast.error(deletePurchaseStatusSuccessAPI?.message);
    }
    dispatch(deletePurchaseStatusSuccess([]));
  }, [deletePurchaseStatusSuccessAPI]);

  // Update Status
  useEffect(() => {
    if (isEmpty(updatePurchaseStatusSuccessAPI)) return;
    if (updatePurchaseStatusSuccessAPI?.status === 200) {
      toast.success(updatePurchaseStatusSuccessAPI?.message);
      dispatch(getPurchaseStatusList());
    } else {
      toast.error(updatePurchaseStatusSuccessAPI?.message);
    }
    dispatch(updatePurchaseStatusSuccess([]));
  }, [updatePurchaseStatusSuccessAPI]);

  // Add New Item Category
  useEffect(() => {
    if (isEmpty(addNewPurchaseItemCategorySuccessAPI)) return;
    if (addNewPurchaseItemCategorySuccessAPI?.status === 200) {
      toast.success(addNewPurchaseItemCategorySuccessAPI?.message);
      dispatch(getPurchaseItemCategoryList());
    } else {
      toast.error(addNewPurchaseItemCategorySuccessAPI?.message);
    }
    dispatch(addNewPurchaseItemCategorySuccess([]));
  }, [addNewPurchaseItemCategorySuccessAPI]);

  // Delete Item Category
  useEffect(() => {
    if (isEmpty(deletePurchaseItemCategorySuccessAPI)) return;
    if (deletePurchaseItemCategorySuccessAPI?.status === 200) {
      toast.success(deletePurchaseItemCategorySuccessAPI?.message);
      dispatch(getPurchaseItemCategoryList());
      setDeleteModal(false);
    } else {
      toast.error(deletePurchaseItemCategorySuccessAPI?.message);
    }
    dispatch(deletePurchaseItemCategorySuccess([]));
  }, [deletePurchaseItemCategorySuccessAPI]);

  // Update Item Category
  useEffect(() => {
    if (isEmpty(updatePurchaseItemCategorySuccessAPI)) return;
    if (updatePurchaseItemCategorySuccessAPI?.status === 200) {
      toast.success(updatePurchaseItemCategorySuccessAPI?.message);
      dispatch(getPurchaseItemCategoryList());
    } else {
      toast.error(updatePurchaseItemCategorySuccessAPI?.message);
    }
    dispatch(updatePurchaseItemCategorySuccess([]));
  }, [updatePurchaseItemCategorySuccessAPI]);

  // Add New Draft Status
  useEffect(() => {
    if (isEmpty(purchaseDraftStatusCreateAPI)) return;
    if (purchaseDraftStatusCreateAPI?.status === 200) {
      toast.success(purchaseDraftStatusCreateAPI?.message);
      dispatch(getPurchaseDraftStatusList());
    } else {
      toast.error(purchaseDraftStatusCreateAPI?.message);
    }
    dispatch(createPurchaseDraftStatusSuccess([]));
  }, [purchaseDraftStatusCreateAPI]);
  // Delete Draft Status
  useEffect(() => {
    if (isEmpty(purchaseDraftStatusDeleteAPI)) return;
    if (purchaseDraftStatusDeleteAPI?.status === 200) {
      toast.success(purchaseDraftStatusDeleteAPI?.message);
      dispatch(getPurchaseDraftStatusList());
      setDeleteModal(false);
    } else {
      toast.error(purchaseDraftStatusDeleteAPI?.message);
    }
    dispatch(deletePurchaseDraftStatusSuccess([]));
  }, [purchaseDraftStatusDeleteAPI]);
  // Update Draft Status
  useEffect(() => {
    if (isEmpty(purchaseDraftStatusUpdateAPI)) return;
    if (purchaseDraftStatusUpdateAPI?.status === 200) {
      toast.success(purchaseDraftStatusUpdateAPI?.message);
      dispatch(getPurchaseDraftStatusList());
    } else {
      toast.error(purchaseDraftStatusUpdateAPI?.message);
    }
    dispatch(updatePurchaseDraftStatusSuccess([]));
  }, [purchaseDraftStatusUpdateAPI]);
  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}

      <SettingsPanel
        title="Purchase Settings"
        description="Statuses and item categories for purchases."
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
          costOfGoodsSold={activeTab === "2"}
        />
      </SettingsPanel>
    </>
  );
}
